import { SimulationListView } from '@nexelem/graphne-api';
import { Status } from '@nexelem/components';
import { AvailableColumnTypes, CustomGridColDef } from '@nexelem/table';
import { useCustomTranslation } from '../../../../../../hooks';
import { simulationStatusMap } from '../mappers/simulationStatusMap';

export const useSimulationListColumns = (): CustomGridColDef<SimulationListView>[] => {
  const { tWrapper } = useCustomTranslation('products.simulationPlan');

  return [
    {
      field: 'id',
      headerName: tWrapper('simulationListColumn.id'),
      sortable: false,
      minWidth: 70,
      align: 'left',
      headerAlign: 'left',
      type: AvailableColumnTypes.number,
    },
    {
      field: 'creationDate',
      headerName: tWrapper('simulationListColumn.creationDate'),
      isDefaultSort: true,
      minWidth: 180,
      type: AvailableColumnTypes.formattedTime,
    },
    {
      field: 'status',
      headerName: tWrapper('simulationListColumn.status'),
      minWidth: 150,
      type: AvailableColumnTypes.custom,
      renderCell: ({ row }) => {
        const status = simulationStatusMap(row.status);
        return (
          status && (
            <Status color={status.color} text={tWrapper(`simulationStatus.${status.label}`)} variant="outlined" />
          )
        );
      },
    },
  ];
};
